// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark mode is the default. No .light class required. */
:root {
  /* Brand */
  --color-primary:        #00DA6D;
  --color-primary-hover:  #00C362;
  --color-primary-deep:   #00593F;
  --color-primary-tint:   #D4FDE9;

  /* Surfaces — dark (anchored to Dark #02140F and Secondary #1C2D2B) */
  --color-bg:             #000000;  /* page canvas — pure black (brand standard) */
  --color-surface:        #101F1A;  /* raised — midpoint between Dark and Secondary */
  --color-surface-2:      #1C2D2B;  /* cards — brand Secondary */
  --color-line:           #243533;  /* hairlines — slightly above Secondary */
  --color-ink:            #101F1A;  /* chip backgrounds & on-green text — brand surface step, visibly above canvas */

  /* Text on dark */
  --color-text-primary:   #EAEAEA;
  --color-text-secondary: #B3B6C1;  /* brand Grey300 */
  --color-text-muted:     #545767;  /* brand Grey400 */

  /* Entities — brightened for dark bg */
  --color-job:            #6B87FF;
  --color-candidate:      #B48AFF;
  --color-report:         #FF8A5C;
  --color-interview:      var(--color-primary);

  /* Type */
  --font-display: "Geist", ui-sans-serif, system-ui, sans-serif;
  --font-ui:      "Inter", ui-sans-serif, system-ui, sans-serif;
  --font-mono:    "JetBrains Mono", ui-monospace, monospace;

  /* Radius */
  --radius-sm:     6px;
  --radius:        10px;
  --radius-lg:     16px;
  --radius-pill:   999px;
  --border-radius: var(--radius);

  /* ── Compat aliases — consumed by existing components ── */
  --color-primary-dark:           var(--color-primary-hover);
  --color-primary-light:          #6BEDB2;
  --color-primary-gradient-start: var(--color-ink);
  --color-primary-gradient-end:   #011009;
  --color-secondary:              var(--color-primary);
  --color-secondary-light:        var(--color-primary-tint);
  --color-accent:                 var(--color-primary-tint);  /* brand Accent #D4FDE9 */
  --color-warning:                #F97316;
  --color-danger:                 #EC4899;
  --color-danger-light:           rgba(236, 72, 153, 0.15);

  /* Pipeline spectrum — stage badge hues not covered by the 4 entity tokens */
  --color-pipeline-sky:           #93C5FD;  /* Approached stage */
  --color-pipeline-cyan:          #67E8F9;  /* Longlisted stage */
  --color-pipeline-teal:          #5EEAD4;  /* Shortlisted / sector research */
  --color-pipeline-pink:          #F9A8D4;  /* Reference checks / interview script */

  /* Entity deep-shade gradient stops */
  --color-job-deep:               #1D4ED8;  /* job gradient endpoint */
  --color-candidate-deep:         #6D28D9;  /* candidate gradient endpoint */
  --color-teal:                   #06B6D4;  /* teal accent (geography icons) */
  --color-teal-deep:              #0891B2;  /* teal gradient endpoint */

  --color-background:             var(--color-bg);
  --color-canvas:                 var(--color-bg);
  --color-paper:                  var(--color-surface-2);
  --color-card-bg:                var(--color-surface-2);
  --color-ink-soft:               var(--color-text-primary);

  --color-text-tertiary:          var(--color-text-secondary);
  --color-success:                var(--color-primary);
  --color-border:                 var(--color-line);

  /* White and legacy aliases */
  --color-white:                  #FFFFFF;  /* pure white — text on colored buttons/chips */
  --white:                        var(--color-surface-2);  /* legacy — maps to dark surface */

  /* Brand grey scale — light (var(--color-bg) = Grey100) → dark (#070707 = Grey600) */
  --color-grey-100:               var(--color-bg);   /* brand Grey100 */
  --color-grey-200:               var(--color-text-primary);   /* brand Grey200 */
  --color-grey-300:               var(--color-text-secondary);   /* brand Grey300 */
  --color-grey-400:               var(--color-text-tertiary);   /* brand Grey400 */
  --color-grey-500:               #232329;   /* brand Grey450 */
  --color-grey-600:               #0E0E10;   /* brand Grey500 */

  --color-gray-50:                var(--color-bg);   /* brand Grey100 */
  --color-gray-100:               var(--color-text-primary);   /* brand Grey200 */
  --color-gray-200:               var(--color-text-secondary);   /* brand Grey300 */
  --color-gray-300:               var(--color-text-tertiary);   /* brand Grey400 */
  --color-gray-400:               var(--color-text-tertiary);   /* brand Grey400 */
  --color-gray-500:               #232329;   /* brand Grey450 */
  --color-gray-600:               #232329;   /* brand Grey450 */
  --color-gray-700:               #0E0E10;   /* brand Grey500 */
  --color-gray-800:               #0E0E10;   /* brand Grey500 */
  --color-gray-900:               #070707;   /* brand Grey600 */

  --radius-md:                    var(--radius);
  --radius-xl:                    var(--radius-lg);
  --radius-2xl:                   var(--radius-lg);
  --radius-full:                  9999px;
  --color-error:                  #EF4444;
  --color-success-bg:             rgba(212, 253, 233, 0.15);
  --color-error-bg:               rgba(239, 68, 68, 0.15);
  --color-warning-bg:             rgba(249, 115, 22, 0.15);
  --color-primary-bg:             rgba(212, 253, 233, 0.12);

  --font-family-sans:             var(--font-ui);
  --font-body:                    var(--font-ui);
  --font-caption:                 var(--font-ui);

  /* Shadows — deeper for dark UI */
  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  --shadow-md: 0 4px 12px -1px rgba(0, 0, 0, 0.5), 0 2px 6px -1px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 16px 32px -4px rgba(0, 0, 0, 0.6), 0 6px 12px -2px rgba(0, 0, 0, 0.5);

  /* Transitions */
  --transition-fast:    150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-default: 300ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Spacing */
  --spacing-1:  0.25rem;
  --spacing-2:  0.5rem;
  --spacing-3:  0.75rem;
  --spacing-4:  1rem;
  --spacing-5:  1.25rem;
  --spacing-6:  1.5rem;
  --spacing-8:  2rem;
  --spacing-10: 2.5rem;
  --spacing-12: 3rem;

  /* Font sizes */
  --font-size-xs:   0.75rem;
  --font-size-sm:   0.875rem;
  --font-size-base: 1rem;
  --font-size-lg:   1.125rem;
  --font-size-xl:   1.25rem;
  --font-size-2xl:  1.5rem;

  /* Font weights */
  --font-weight-normal:   400;
  --font-weight-medium:   500;
  --font-weight-semibold: 600;
  --font-weight-bold:     700;

  /* Type-scale tokens */
  --text-hero: 2.125rem;
  --text-lg:   1.125rem;
  --text-base: 0.9375rem;
  --text-sm:   0.8125rem;
  --text-xs:   0.6875rem;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  font-family: var(--font-body);
  background-color: var(--color-background);
  color: var(--color-text-primary);
  margin: 0;
  padding: 0;
  line-height: 1.5;
  font-size: var(--font-size-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ── Global selection highlight — prevents dark bg on paste into Word/Docs ── */
::selection {
  background-color: #b3d4fc;
  color: #111111;
}
::-webkit-selection {
  background-color: #b3d4fc;
  color: #111111;
}

/* ── Typography: Geist for display, JetBrains Mono for code/metadata ── */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-display);
}

code, pre, kbd, samp {
  font-family: var(--font-mono);
  font-size: 0.875em;
}

/* Label / metadata utility class */
.font-mono,
.label-mono,
[class*="stat-value"],
[class*="badge"],
[class*="tag"] {
  font-family: var(--font-mono);
}

/* ── Global form-control baseline ── */
input,
textarea,
select {
  background-color: var(--color-surface);
  border: 1px solid var(--color-line);
  color: var(--color-text-primary);
  border-radius: var(--radius-sm);
  font-family: inherit;
  font-size: var(--font-size-sm);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}
input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.25);
}
input::placeholder,
textarea::placeholder {
  color: var(--color-text-tertiary);
}

/* Typography Styles */
h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: var(--spacing-4);
  font-weight: var(--font-weight-bold);
  line-height: 1.2;
}

h1 {
  font-size: var(--font-size-2xl);
  color: var(--color-text-primary);
}

h2 {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

h3 {
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
}

p {
  margin-top: 0;
  margin-bottom: var(--spacing-4);
  color: var(--color-text-secondary);
}

/* Card Styles */
.card {
  background-color: var(--color-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-line);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-6);
  transition: all var(--transition-default);
}

.card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 18px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  outline: none;
  text-decoration: none;
  font-family: inherit;
  white-space: nowrap;
}

.btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.5);
}

.btn-primary {
  background: var(--color-primary);
  color: var(--color-ink);
}

.btn-primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
  box-shadow: 0 4px 12px rgba(0, 218, 109, 0.3);
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-secondary {
  background-color: transparent;
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
}

.btn-secondary:hover {
  background-color: rgba(0, 218, 109, 0.05);
}

.btn-danger {
  background-color: var(--color-error);
  color: var(--color-ink);
}

.btn-danger:hover:not(:disabled) {
  filter: brightness(1.1);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  transform: translateY(-1px);
}

.btn-danger:active:not(:disabled) {
  transform: translateY(0);
}

.btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-icon {
  margin-right: var(--spacing-2);
}

/* Utility Classes */
.text-gradient {
  color: var(--color-primary);
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: currentColor;
  background-clip: unset;
}

.bg-gradient {
  background: var(--color-surface);
}

.text-success {
  color: var(--color-secondary);
}

.text-warning {
  color: var(--color-warning);
}

.text-danger {
  color: var(--color-danger);
}

.text-accent {
  color: var(--color-accent);
}

/* Login Page */
.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 1rem;
  background: var(--color-bg);
}

.login-container {
  margin: 0 auto;
  width: 100%;
  max-width: 28rem;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-logo {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}

.hr-logo {
  height: 60px;
  object-fit: contain;
  margin-bottom: 10px;
}

.login-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 1rem;
}

.login-brand-wordmark {
  font-size: 1.875rem;
  font-weight: 800;
  color: var(--color-text-primary);
  letter-spacing: -0.02em;
}

.login-title {
  font-size: 1.875rem;
  font-weight: 800;
  color: var(--color-primary);
  margin-bottom: 0.5rem;
}

.login-subtitle {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
}

.login-form-container {
  background-color: var(--color-surface-2);
  border: 1px solid var(--color-line);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: var(--shadow-md);
}

/* Form styles */
.form-group {
  margin-bottom: var(--spacing-5);
}

.form-label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-2);
}

.form-label .required {
  color: var(--color-danger);
  margin-left: var(--spacing-1);
}

.form-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--color-line);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  background-color: var(--color-surface);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.25);
}

.form-input:hover:not(:focus) {
  border-color: rgba(0, 218, 109, 0.35);
}

.form-input::placeholder {
  color: var(--color-text-tertiary);
}

.form-input.error {
  border-color: var(--color-danger);
  background-color: rgba(236, 72, 153, 0.02);
}

.form-error {
  margin-top: var(--spacing-2);
  font-size: var(--font-size-xs);
  color: var(--color-danger);
  display: flex;
  align-items: center;
}

.form-error svg {
  margin-right: var(--spacing-1);
}

.form-hint {
  margin-top: var(--spacing-1);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.form-group-inline {
  display: flex;
  gap: var(--spacing-4);
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-3);
}

.checkbox-input {
  margin-right: var(--spacing-2);
  width: 16px;
  height: 16px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-text-tertiary);
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  cursor: pointer;
}

.checkbox-input:checked {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.checkbox-input:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label {
  font-size: var(--font-size-sm);
  cursor: pointer;
}

.form-button {
  display: block;
  width: 100%;
  padding: 0.75rem 1.25rem;
  background: var(--color-primary);
  color: var(--color-ink);
  border: none;
  border-radius: 12px;
  font-weight: var(--font-weight-medium);
  font-size: 1rem;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-default);
  box-shadow: 0 4px 14px rgba(0, 218, 109, 0.3);
}

.form-button:hover {
  background: var(--color-primary-dark);
  box-shadow: 0 4px 6px -1px rgba(0, 218, 109, 0.3);
  transform: translateY(-1px);
}

.form-button:disabled {
  background: var(--color-text-tertiary);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.forgot-password {
  display: block;
  text-align: right;
  font-size: 0.75rem;
  margin-bottom: 1.25rem;
}

.forgot-password a {
  color: var(--color-primary);
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}

.oauth-divider {
  margin-top: 1.5rem;
  position: relative;
}

.oauth-divider-line {
  position: absolute;
  top: 50%;
  width: 100%;
  border-top: 1px solid var(--color-line);
}

.oauth-divider-text {
  position: relative;
  display: flex;
  justify-content: center;
}

.oauth-divider-text span {
  padding: 0 0.5rem;
  background-color: var(--color-surface-2);
  color: var(--color-text-secondary);
  font-size: 0.75rem;
}

.oauth-buttons {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.oauth-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.625rem 1rem;
  border: 1px solid var(--color-line);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  background-color: var(--color-surface);
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  transition: all var(--transition-default);
  text-decoration: none;
}

.oauth-button:hover {
  background-color: var(--color-bg);
  border-color: var(--color-text-secondary);
}

.oauth-button svg {
  margin-right: 0.5rem;
}

.oauth-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.oauth-button:disabled:hover {
  background-color: white;
  border-color: var(--color-text-tertiary);
}

.oauth-spinner {
  animation: oauth-spin 1s linear infinite;
  margin-right: 0;
}

@keyframes oauth-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.signup-prompt {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: var(--color-text-tertiary);
}

.signup-prompt a,
.verification-prompt a {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 500;
}

.signup-prompt a:hover,
.verification-prompt a:hover {
  text-decoration: underline;
}

.verification-prompt {
  margin: 1rem 0 0;
  text-align: center;
  font-size: 0.875rem;
}

.verification-link {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.verification-prompt a:focus-visible,
.verification-link:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 3px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Layout Patterns */
.container {
  width: 100%;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding-left: var(--spacing-4);
  padding-right: var(--spacing-4);
}

.section {
  margin-top: var(--spacing-8);
  margin-bottom: var(--spacing-8);
}

.section-header {
  margin-bottom: var(--spacing-6);
  position: relative;
}

.section-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-2);
}

.section-subtitle {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
}

.page-header {
  background: linear-gradient(to right, var(--color-primary-gradient-start), var(--color-primary-gradient-end));
  color: white;
  padding: var(--spacing-8) 0;
  margin-bottom: var(--spacing-8);
}

.page-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-2);
  color: white;
}

.page-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--font-size-base);
  margin-bottom: 0;
}

/* Grid System */
.grid {
  display: grid;
  gap: var(--spacing-6);
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 640px) {
  .grid-cols-sm-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .grid-cols-md-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .grid-cols-md-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .grid-cols-lg-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  
  .grid-cols-lg-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

/* Flexbox Utilities */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.flex-1 {
  flex: 1;
}

.gap-2 {
  gap: var(--spacing-2);
}

.gap-4 {
  gap: var(--spacing-4);
}

.gap-6 {
  gap: var(--spacing-6);
}

/* Two-column Layout for Detail Pages */
.two-col-layout {
  display: grid;
  gap: var(--spacing-6);
  grid-template-columns: 1fr;
}

@media (min-width: 768px) {
  .two-col-layout {
    grid-template-columns: 2fr 1fr;
  }
}

/* Sidebar */
.sidebar {
  background-color: var(--color-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-line);
  padding: var(--spacing-6);
}

/* Data Cards */
.metric-card {
  display: flex;
  flex-direction: column;
  background-color: var(--color-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-line);
  padding: var(--spacing-6);
  position: relative;
  overflow: hidden;
}

.metric-card-icon {
  position: absolute;
  top: var(--spacing-4);
  right: var(--spacing-4);
  color: var(--color-primary);
  opacity: 0.15;
  font-size: 24px;
}

.metric-card-title {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-2);
}

.metric-card-value {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-1);
}

.metric-card-trend {
  display: flex;
  align-items: center;
  font-size: var(--font-size-xs);
}

.metric-card-trend.positive {
  color: var(--color-secondary);
}

.metric-card-trend.negative {
  color: var(--color-danger);
}

/* Tabs */
.tabs {
  display: flex;
  border-bottom: 1px solid var(--color-line);
  margin-bottom: var(--spacing-6);
}

.tab {
  padding: var(--spacing-3) var(--spacing-4);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all var(--transition-default);
}

.tab:hover {
  color: var(--color-text-primary);
}

.tab.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}

/* Animation Utilities */
.animate-fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

.animate-slide-up {
  animation: slideUp 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Empty States */
.empty-state {
  padding: var(--spacing-10);
  text-align: center;
  color: var(--color-text-secondary);
}

.empty-state-icon {
  font-size: 48px;
  color: var(--color-text-tertiary);
  margin-bottom: var(--spacing-4);
}

.empty-state-title {
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-2);
}

.empty-state-description {
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-6);
}

/* Table Styling */
.table-container {
  overflow-x: auto;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  background-color: var(--color-surface);
  border: 1px solid var(--color-line);
}

table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  font-size: var(--font-size-sm);
}

thead {
  background-color: var(--color-bg);
  border-bottom: 1px solid var(--color-line);
}

th {
  text-align: left;
  padding: var(--spacing-4);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  position: relative;
}

th.sortable {
  cursor: pointer;
}

th.sortable:hover {
  background-color: var(--color-surface);
}

th.sorted-asc::after,
th.sorted-desc::after {
  content: '';
  position: absolute;
  right: var(--spacing-4);
  top: 50%;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

th.sorted-asc::after {
  border-bottom: 4px solid var(--color-text-primary);
  transform: translateY(-60%);
}

th.sorted-desc::after {
  border-top: 4px solid var(--color-text-primary);
  transform: translateY(-40%);
}

td {
  padding: var(--spacing-4);
  border-bottom: 1px solid var(--color-line);
  color: var(--color-text-primary);
}

tr:last-child td {
  border-bottom: none;
}

tr:hover td {
  background-color: var(--color-bg);
}

.table-actions {
  display: flex;
  gap: var(--spacing-2);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--radius-md);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
}

.status-badge.active {
  background-color: rgba(0, 218, 109, 0.1);
  color: var(--color-secondary);
}

.status-badge.closed,
.status-badge.rejected {
  background-color: rgba(236, 72, 153, 0.1);
  color: var(--color-danger);
}

.status-badge.draft,
.status-badge.contacted {
  background-color: rgba(180, 138, 255, 0.1);
  color: var(--color-accent);
}

.status-badge.interviewing,
.status-badge.pending {
  background-color: rgba(249, 115, 22, 0.1);
  color: var(--color-warning);
}

.status-badge.hired {
  background: linear-gradient(to right, rgba(107, 135, 255, 0.1), rgba(99, 102, 241, 0.1));
  color: var(--color-primary);
}

.table-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-4);
  border-top: 1px solid var(--color-line);
}

.pagination-info {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.pagination-controls {
  display: flex;
  gap: var(--spacing-1);
}

.pagination-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-line);
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  transition: all var(--transition-default);
  cursor: pointer;
}

.pagination-button:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.pagination-button.active {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: white;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,qEAAqE;EACrE,+BAA+B,GAAG,8CAA8C;EAChF,+BAA+B,GAAG,iDAAiD;EACnF,+BAA+B,GAAG,4BAA4B;EAC9D,+BAA+B,GAAG,yCAAyC;EAC3E,+BAA+B,GAAG,gFAAgF;;EAElH,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B,GAAG,kBAAkB;EACpD,+BAA+B,GAAG,kBAAkB;;EAEpD,sCAAsC;EACtC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,4CAA4C;;EAE5C,SAAS;EACT,6DAA6D;EAC7D,6DAA6D;EAC7D,yDAAyD;;EAEzD,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;;EAE9B,2DAA2D;EAC3D,0DAA0D;EAC1D,uCAAuC;EACvC,gDAAgD;EAChD,uCAAuC;EACvC,oDAAoD;EACpD,yDAAyD;EACzD,yDAAyD,GAAG,yBAAyB;EACrF,uCAAuC;EACvC,uCAAuC;EACvC,wDAAwD;;EAExD,4EAA4E;EAC5E,uCAAuC,GAAG,qBAAqB;EAC/D,uCAAuC,GAAG,qBAAqB;EAC/D,uCAAuC,GAAG,kCAAkC;EAC5E,uCAAuC,GAAG,wCAAwC;;EAElF,qCAAqC;EACrC,uCAAuC,GAAG,0BAA0B;EACpE,uCAAuC,GAAG,gCAAgC;EAC1E,uCAAuC,GAAG,kCAAkC;EAC5E,uCAAuC,GAAG,2BAA2B;;EAErE,+CAA+C;EAC/C,+CAA+C;EAC/C,sDAAsD;EACtD,sDAAsD;EACtD,yDAAyD;;EAEzD,2DAA2D;EAC3D,oDAAoD;EACpD,iDAAiD;;EAEjD,6BAA6B;EAC7B,uCAAuC,GAAG,+CAA+C;EACzF,sDAAsD,GAAG,kCAAkC;;EAE3F,oFAAoF;EACpF,+CAA+C,IAAI,kBAAkB;EACrE,yDAAyD,IAAI,kBAAkB;EAC/E,2DAA2D,IAAI,kBAAkB;EACjF,0DAA0D,IAAI,kBAAkB;EAChF,uCAAuC,IAAI,kBAAkB;EAC7D,uCAAuC,IAAI,kBAAkB;;EAE7D,+CAA+C,IAAI,kBAAkB;EACrE,yDAAyD,IAAI,kBAAkB;EAC/E,2DAA2D,IAAI,kBAAkB;EACjF,0DAA0D,IAAI,kBAAkB;EAChF,0DAA0D,IAAI,kBAAkB;EAChF,uCAAuC,IAAI,kBAAkB;EAC7D,uCAAuC,IAAI,kBAAkB;EAC7D,uCAAuC,IAAI,kBAAkB;EAC7D,uCAAuC,IAAI,kBAAkB;EAC7D,uCAAuC,IAAI,kBAAkB;;EAE7D,6CAA6C;EAC7C,gDAAgD;EAChD,gDAAgD;EAChD,sCAAsC;EACtC,uCAAuC;EACvC,yDAAyD;EACzD,uDAAuD;EACvD,wDAAwD;EACxD,yDAAyD;;EAEzD,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;;EAE9C,iCAAiC;EACjC,2CAA2C;EAC3C,kFAAkF;EAClF,oFAAoF;;EAEpF,gBAAgB;EAChB,wDAAwD;EACxD,wDAAwD;;EAExD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;;EAElB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;;EAExB,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,gFAAgF;AAChF;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;;;;;EAKE,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;;;EAGE,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,oBAAoB;EACpB,8BAA8B;EAC9B,0DAA0D;AAC5D;AACA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;AACA;;EAEE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4CAA4C;EAC5C,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,6GAA6G;EAC7G,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,YAAY;AACZ;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;;EAEE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;;EAEE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;;EAEE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,sCAAsC;EACtC,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Dark mode is the default. No .light class required. */\n:root {\n  /* Brand */\n  --color-primary:        #00DA6D;\n  --color-primary-hover:  #00C362;\n  --color-primary-deep:   #00593F;\n  --color-primary-tint:   #D4FDE9;\n\n  /* Surfaces — dark (anchored to Dark #02140F and Secondary #1C2D2B) */\n  --color-bg:             #000000;  /* page canvas — pure black (brand standard) */\n  --color-surface:        #101F1A;  /* raised — midpoint between Dark and Secondary */\n  --color-surface-2:      #1C2D2B;  /* cards — brand Secondary */\n  --color-line:           #243533;  /* hairlines — slightly above Secondary */\n  --color-ink:            #101F1A;  /* chip backgrounds & on-green text — brand surface step, visibly above canvas */\n\n  /* Text on dark */\n  --color-text-primary:   #EAEAEA;\n  --color-text-secondary: #B3B6C1;  /* brand Grey300 */\n  --color-text-muted:     #545767;  /* brand Grey400 */\n\n  /* Entities — brightened for dark bg */\n  --color-job:            #6B87FF;\n  --color-candidate:      #B48AFF;\n  --color-report:         #FF8A5C;\n  --color-interview:      var(--color-primary);\n\n  /* Type */\n  --font-display: \"Geist\", ui-sans-serif, system-ui, sans-serif;\n  --font-ui:      \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  --font-mono:    \"JetBrains Mono\", ui-monospace, monospace;\n\n  /* Radius */\n  --radius-sm:     6px;\n  --radius:        10px;\n  --radius-lg:     16px;\n  --radius-pill:   999px;\n  --border-radius: var(--radius);\n\n  /* ── Compat aliases — consumed by existing components ── */\n  --color-primary-dark:           var(--color-primary-hover);\n  --color-primary-light:          #6BEDB2;\n  --color-primary-gradient-start: var(--color-ink);\n  --color-primary-gradient-end:   #011009;\n  --color-secondary:              var(--color-primary);\n  --color-secondary-light:        var(--color-primary-tint);\n  --color-accent:                 var(--color-primary-tint);  /* brand Accent #D4FDE9 */\n  --color-warning:                #F97316;\n  --color-danger:                 #EC4899;\n  --color-danger-light:           rgba(236, 72, 153, 0.15);\n\n  /* Pipeline spectrum — stage badge hues not covered by the 4 entity tokens */\n  --color-pipeline-sky:           #93C5FD;  /* Approached stage */\n  --color-pipeline-cyan:          #67E8F9;  /* Longlisted stage */\n  --color-pipeline-teal:          #5EEAD4;  /* Shortlisted / sector research */\n  --color-pipeline-pink:          #F9A8D4;  /* Reference checks / interview script */\n\n  /* Entity deep-shade gradient stops */\n  --color-job-deep:               #1D4ED8;  /* job gradient endpoint */\n  --color-candidate-deep:         #6D28D9;  /* candidate gradient endpoint */\n  --color-teal:                   #06B6D4;  /* teal accent (geography icons) */\n  --color-teal-deep:              #0891B2;  /* teal gradient endpoint */\n\n  --color-background:             var(--color-bg);\n  --color-canvas:                 var(--color-bg);\n  --color-paper:                  var(--color-surface-2);\n  --color-card-bg:                var(--color-surface-2);\n  --color-ink-soft:               var(--color-text-primary);\n\n  --color-text-tertiary:          var(--color-text-secondary);\n  --color-success:                var(--color-primary);\n  --color-border:                 var(--color-line);\n\n  /* White and legacy aliases */\n  --color-white:                  #FFFFFF;  /* pure white — text on colored buttons/chips */\n  --white:                        var(--color-surface-2);  /* legacy — maps to dark surface */\n\n  /* Brand grey scale — light (var(--color-bg) = Grey100) → dark (#070707 = Grey600) */\n  --color-grey-100:               var(--color-bg);   /* brand Grey100 */\n  --color-grey-200:               var(--color-text-primary);   /* brand Grey200 */\n  --color-grey-300:               var(--color-text-secondary);   /* brand Grey300 */\n  --color-grey-400:               var(--color-text-tertiary);   /* brand Grey400 */\n  --color-grey-500:               #232329;   /* brand Grey450 */\n  --color-grey-600:               #0E0E10;   /* brand Grey500 */\n\n  --color-gray-50:                var(--color-bg);   /* brand Grey100 */\n  --color-gray-100:               var(--color-text-primary);   /* brand Grey200 */\n  --color-gray-200:               var(--color-text-secondary);   /* brand Grey300 */\n  --color-gray-300:               var(--color-text-tertiary);   /* brand Grey400 */\n  --color-gray-400:               var(--color-text-tertiary);   /* brand Grey400 */\n  --color-gray-500:               #232329;   /* brand Grey450 */\n  --color-gray-600:               #232329;   /* brand Grey450 */\n  --color-gray-700:               #0E0E10;   /* brand Grey500 */\n  --color-gray-800:               #0E0E10;   /* brand Grey500 */\n  --color-gray-900:               #070707;   /* brand Grey600 */\n\n  --radius-md:                    var(--radius);\n  --radius-xl:                    var(--radius-lg);\n  --radius-2xl:                   var(--radius-lg);\n  --radius-full:                  9999px;\n  --color-error:                  #EF4444;\n  --color-success-bg:             rgba(212, 253, 233, 0.15);\n  --color-error-bg:               rgba(239, 68, 68, 0.15);\n  --color-warning-bg:             rgba(249, 115, 22, 0.15);\n  --color-primary-bg:             rgba(212, 253, 233, 0.12);\n\n  --font-family-sans:             var(--font-ui);\n  --font-body:                    var(--font-ui);\n  --font-caption:                 var(--font-ui);\n\n  /* Shadows — deeper for dark UI */\n  --shadow-sm: 0 1px 3px 0 rgba(0, 0, 0, 0.4);\n  --shadow-md: 0 4px 12px -1px rgba(0, 0, 0, 0.5), 0 2px 6px -1px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 16px 32px -4px rgba(0, 0, 0, 0.6), 0 6px 12px -2px rgba(0, 0, 0, 0.5);\n\n  /* Transitions */\n  --transition-fast:    150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-default: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Spacing */\n  --spacing-1:  0.25rem;\n  --spacing-2:  0.5rem;\n  --spacing-3:  0.75rem;\n  --spacing-4:  1rem;\n  --spacing-5:  1.25rem;\n  --spacing-6:  1.5rem;\n  --spacing-8:  2rem;\n  --spacing-10: 2.5rem;\n  --spacing-12: 3rem;\n\n  /* Font sizes */\n  --font-size-xs:   0.75rem;\n  --font-size-sm:   0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg:   1.125rem;\n  --font-size-xl:   1.25rem;\n  --font-size-2xl:  1.5rem;\n\n  /* Font weights */\n  --font-weight-normal:   400;\n  --font-weight-medium:   500;\n  --font-weight-semibold: 600;\n  --font-weight-bold:     700;\n\n  /* Type-scale tokens */\n  --text-hero: 2.125rem;\n  --text-lg:   1.125rem;\n  --text-base: 0.9375rem;\n  --text-sm:   0.8125rem;\n  --text-xs:   0.6875rem;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-body);\n  background-color: var(--color-background);\n  color: var(--color-text-primary);\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n  font-size: var(--font-size-base);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ── Global selection highlight — prevents dark bg on paste into Word/Docs ── */\n::selection {\n  background-color: #b3d4fc;\n  color: #111111;\n}\n::-webkit-selection {\n  background-color: #b3d4fc;\n  color: #111111;\n}\n\n/* ── Typography: Geist for display, JetBrains Mono for code/metadata ── */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-display);\n}\n\ncode, pre, kbd, samp {\n  font-family: var(--font-mono);\n  font-size: 0.875em;\n}\n\n/* Label / metadata utility class */\n.font-mono,\n.label-mono,\n[class*=\"stat-value\"],\n[class*=\"badge\"],\n[class*=\"tag\"] {\n  font-family: var(--font-mono);\n}\n\n/* ── Global form-control baseline ── */\ninput,\ntextarea,\nselect {\n  background-color: var(--color-surface);\n  border: 1px solid var(--color-line);\n  color: var(--color-text-primary);\n  border-radius: var(--radius-sm);\n  font-family: inherit;\n  font-size: var(--font-size-sm);\n  transition: border-color 150ms ease, box-shadow 150ms ease;\n}\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.25);\n}\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n/* Typography Styles */\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: var(--spacing-4);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.2;\n}\n\nh1 {\n  font-size: var(--font-size-2xl);\n  color: var(--color-text-primary);\n}\n\nh2 {\n  font-size: var(--font-size-xl);\n  color: var(--color-text-primary);\n}\n\nh3 {\n  font-size: var(--font-size-lg);\n  color: var(--color-text-primary);\n}\n\np {\n  margin-top: 0;\n  margin-bottom: var(--spacing-4);\n  color: var(--color-text-secondary);\n}\n\n/* Card Styles */\n.card {\n  background-color: var(--color-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-line);\n  box-shadow: var(--shadow-md);\n  padding: var(--spacing-6);\n  transition: all var(--transition-default);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-2px);\n}\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 9px 18px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  outline: none;\n  text-decoration: none;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.5);\n}\n\n.btn-primary {\n  background: var(--color-primary);\n  color: var(--color-ink);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--color-primary-hover);\n  box-shadow: 0 4px 12px rgba(0, 218, 109, 0.3);\n  transform: translateY(-1px);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.btn-secondary {\n  background-color: transparent;\n  border: 1px solid var(--color-primary);\n  color: var(--color-primary);\n}\n\n.btn-secondary:hover {\n  background-color: rgba(0, 218, 109, 0.05);\n}\n\n.btn-danger {\n  background-color: var(--color-error);\n  color: var(--color-ink);\n}\n\n.btn-danger:hover:not(:disabled) {\n  filter: brightness(1.1);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n  transform: translateY(-1px);\n}\n\n.btn-danger:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-danger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.btn-icon {\n  margin-right: var(--spacing-2);\n}\n\n/* Utility Classes */\n.text-gradient {\n  color: var(--color-primary);\n  background: none;\n  -webkit-background-clip: unset;\n  -webkit-text-fill-color: currentColor;\n  background-clip: unset;\n}\n\n.bg-gradient {\n  background: var(--color-surface);\n}\n\n.text-success {\n  color: var(--color-secondary);\n}\n\n.text-warning {\n  color: var(--color-warning);\n}\n\n.text-danger {\n  color: var(--color-danger);\n}\n\n.text-accent {\n  color: var(--color-accent);\n}\n\n/* Login Page */\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 2rem 1rem;\n  background: var(--color-bg);\n}\n\n.login-container {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 28rem;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.login-logo {\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n\n.hr-logo {\n  height: 60px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.login-brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 1rem;\n}\n\n.login-brand-wordmark {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: var(--color-text-primary);\n  letter-spacing: -0.02em;\n}\n\n.login-title {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: var(--color-primary);\n  margin-bottom: 0.5rem;\n}\n\n.login-subtitle {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n}\n\n.login-form-container {\n  background-color: var(--color-surface-2);\n  border: 1px solid var(--color-line);\n  padding: 2rem;\n  border-radius: 16px;\n  box-shadow: var(--shadow-md);\n}\n\n/* Form styles */\n.form-group {\n  margin-bottom: var(--spacing-5);\n}\n\n.form-label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-2);\n}\n\n.form-label .required {\n  color: var(--color-danger);\n  margin-left: var(--spacing-1);\n}\n\n.form-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--color-line);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  background-color: var(--color-surface);\n  transition: border-color 150ms ease, box-shadow 150ms ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(0, 218, 109, 0.25);\n}\n\n.form-input:hover:not(:focus) {\n  border-color: rgba(0, 218, 109, 0.35);\n}\n\n.form-input::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.form-input.error {\n  border-color: var(--color-danger);\n  background-color: rgba(236, 72, 153, 0.02);\n}\n\n.form-error {\n  margin-top: var(--spacing-2);\n  font-size: var(--font-size-xs);\n  color: var(--color-danger);\n  display: flex;\n  align-items: center;\n}\n\n.form-error svg {\n  margin-right: var(--spacing-1);\n}\n\n.form-hint {\n  margin-top: var(--spacing-1);\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.form-group-inline {\n  display: flex;\n  gap: var(--spacing-4);\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.checkbox-input {\n  margin-right: var(--spacing-2);\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--color-text-tertiary);\n  appearance: none;\n  -webkit-appearance: none;\n  position: relative;\n  cursor: pointer;\n}\n\n.checkbox-input:checked {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.checkbox-input:checked::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.checkbox-label {\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n}\n\n.form-button {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1.25rem;\n  background: var(--color-primary);\n  color: var(--color-ink);\n  border: none;\n  border-radius: 12px;\n  font-weight: var(--font-weight-medium);\n  font-size: 1rem;\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-default);\n  box-shadow: 0 4px 14px rgba(0, 218, 109, 0.3);\n}\n\n.form-button:hover {\n  background: var(--color-primary-dark);\n  box-shadow: 0 4px 6px -1px rgba(0, 218, 109, 0.3);\n  transform: translateY(-1px);\n}\n\n.form-button:disabled {\n  background: var(--color-text-tertiary);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.forgot-password {\n  display: block;\n  text-align: right;\n  font-size: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.forgot-password a {\n  color: var(--color-primary);\n  text-decoration: none;\n}\n\n.forgot-password a:hover {\n  text-decoration: underline;\n}\n\n.oauth-divider {\n  margin-top: 1.5rem;\n  position: relative;\n}\n\n.oauth-divider-line {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  border-top: 1px solid var(--color-line);\n}\n\n.oauth-divider-text {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.oauth-divider-text span {\n  padding: 0 0.5rem;\n  background-color: var(--color-surface-2);\n  color: var(--color-text-secondary);\n  font-size: 0.75rem;\n}\n\n.oauth-buttons {\n  margin-top: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.75rem;\n}\n\n.oauth-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.625rem 1rem;\n  border: 1px solid var(--color-line);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  background-color: var(--color-surface);\n  color: var(--color-text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all var(--transition-default);\n  text-decoration: none;\n}\n\n.oauth-button:hover {\n  background-color: var(--color-bg);\n  border-color: var(--color-text-secondary);\n}\n\n.oauth-button svg {\n  margin-right: 0.5rem;\n}\n\n.oauth-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.oauth-button:disabled:hover {\n  background-color: white;\n  border-color: var(--color-text-tertiary);\n}\n\n.oauth-spinner {\n  animation: oauth-spin 1s linear infinite;\n  margin-right: 0;\n}\n\n@keyframes oauth-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.signup-prompt {\n  margin-top: 1.5rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: var(--color-text-tertiary);\n}\n\n.signup-prompt a,\n.verification-prompt a {\n  color: var(--color-primary);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.signup-prompt a:hover,\n.verification-prompt a:hover {\n  text-decoration: underline;\n}\n\n.verification-prompt {\n  margin: 1rem 0 0;\n  text-align: center;\n  font-size: 0.875rem;\n}\n\n.verification-link {\n  color: var(--color-primary);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.verification-prompt a:focus-visible,\n.verification-link:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 3px;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* Layout Patterns */\n.container {\n  width: 100%;\n  max-width: 1280px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: var(--spacing-4);\n  padding-right: var(--spacing-4);\n}\n\n.section {\n  margin-top: var(--spacing-8);\n  margin-bottom: var(--spacing-8);\n}\n\n.section-header {\n  margin-bottom: var(--spacing-6);\n  position: relative;\n}\n\n.section-title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--spacing-2);\n}\n\n.section-subtitle {\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n.page-header {\n  background: linear-gradient(to right, var(--color-primary-gradient-start), var(--color-primary-gradient-end));\n  color: white;\n  padding: var(--spacing-8) 0;\n  margin-bottom: var(--spacing-8);\n}\n\n.page-title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  margin-bottom: var(--spacing-2);\n  color: white;\n}\n\n.page-description {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: var(--font-size-base);\n  margin-bottom: 0;\n}\n\n/* Grid System */\n.grid {\n  display: grid;\n  gap: var(--spacing-6);\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 640px) {\n  .grid-cols-sm-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .grid-cols-md-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  \n  .grid-cols-md-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .grid-cols-lg-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  \n  .grid-cols-lg-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n/* Flexbox Utilities */\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.gap-2 {\n  gap: var(--spacing-2);\n}\n\n.gap-4 {\n  gap: var(--spacing-4);\n}\n\n.gap-6 {\n  gap: var(--spacing-6);\n}\n\n/* Two-column Layout for Detail Pages */\n.two-col-layout {\n  display: grid;\n  gap: var(--spacing-6);\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 768px) {\n  .two-col-layout {\n    grid-template-columns: 2fr 1fr;\n  }\n}\n\n/* Sidebar */\n.sidebar {\n  background-color: var(--color-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-line);\n  padding: var(--spacing-6);\n}\n\n/* Data Cards */\n.metric-card {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-line);\n  padding: var(--spacing-6);\n  position: relative;\n  overflow: hidden;\n}\n\n.metric-card-icon {\n  position: absolute;\n  top: var(--spacing-4);\n  right: var(--spacing-4);\n  color: var(--color-primary);\n  opacity: 0.15;\n  font-size: 24px;\n}\n\n.metric-card-title {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-2);\n}\n\n.metric-card-value {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--spacing-1);\n}\n\n.metric-card-trend {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-xs);\n}\n\n.metric-card-trend.positive {\n  color: var(--color-secondary);\n}\n\n.metric-card-trend.negative {\n  color: var(--color-danger);\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  border-bottom: 1px solid var(--color-line);\n  margin-bottom: var(--spacing-6);\n}\n\n.tab {\n  padding: var(--spacing-3) var(--spacing-4);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-secondary);\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all var(--transition-default);\n}\n\n.tab:hover {\n  color: var(--color-text-primary);\n}\n\n.tab.active {\n  color: var(--color-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n/* Animation Utilities */\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.animate-slide-up {\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Empty States */\n.empty-state {\n  padding: var(--spacing-10);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.empty-state-icon {\n  font-size: 48px;\n  color: var(--color-text-tertiary);\n  margin-bottom: var(--spacing-4);\n}\n\n.empty-state-title {\n  font-size: var(--font-size-lg);\n  color: var(--color-text-primary);\n  margin-bottom: var(--spacing-2);\n}\n\n.empty-state-description {\n  color: var(--color-text-secondary);\n  margin-bottom: var(--spacing-6);\n}\n\n/* Table Styling */\n.table-container {\n  overflow-x: auto;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  background-color: var(--color-surface);\n  border: 1px solid var(--color-line);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  white-space: nowrap;\n  font-size: var(--font-size-sm);\n}\n\nthead {\n  background-color: var(--color-bg);\n  border-bottom: 1px solid var(--color-line);\n}\n\nth {\n  text-align: left;\n  padding: var(--spacing-4);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  position: relative;\n}\n\nth.sortable {\n  cursor: pointer;\n}\n\nth.sortable:hover {\n  background-color: var(--color-surface);\n}\n\nth.sorted-asc::after,\nth.sorted-desc::after {\n  content: '';\n  position: absolute;\n  right: var(--spacing-4);\n  top: 50%;\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n}\n\nth.sorted-asc::after {\n  border-bottom: 4px solid var(--color-text-primary);\n  transform: translateY(-60%);\n}\n\nth.sorted-desc::after {\n  border-top: 4px solid var(--color-text-primary);\n  transform: translateY(-40%);\n}\n\ntd {\n  padding: var(--spacing-4);\n  border-bottom: 1px solid var(--color-line);\n  color: var(--color-text-primary);\n}\n\ntr:last-child td {\n  border-bottom: none;\n}\n\ntr:hover td {\n  background-color: var(--color-bg);\n}\n\n.table-actions {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n}\n\n.status-badge.active {\n  background-color: rgba(0, 218, 109, 0.1);\n  color: var(--color-secondary);\n}\n\n.status-badge.closed,\n.status-badge.rejected {\n  background-color: rgba(236, 72, 153, 0.1);\n  color: var(--color-danger);\n}\n\n.status-badge.draft,\n.status-badge.contacted {\n  background-color: rgba(180, 138, 255, 0.1);\n  color: var(--color-accent);\n}\n\n.status-badge.interviewing,\n.status-badge.pending {\n  background-color: rgba(249, 115, 22, 0.1);\n  color: var(--color-warning);\n}\n\n.status-badge.hired {\n  background: linear-gradient(to right, rgba(107, 135, 255, 0.1), rgba(99, 102, 241, 0.1));\n  color: var(--color-primary);\n}\n\n.table-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-4);\n  border-top: 1px solid var(--color-line);\n}\n\n.pagination-info {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n.pagination-controls {\n  display: flex;\n  gap: var(--spacing-1);\n}\n\n.pagination-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-line);\n  background-color: var(--color-surface);\n  color: var(--color-text-primary);\n  transition: all var(--transition-default);\n  cursor: pointer;\n}\n\n.pagination-button:hover {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n.pagination-button.active {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n  color: white;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
